import { render, staticRenderFns } from "./ServiceAreaModal.vue?vue&type=template&id=61899ce1&scoped=true&"
import script from "./ServiceAreaModal.vue?vue&type=script&lang=js&"
export * from "./ServiceAreaModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreaModal.vue?vue&type=style&index=0&id=61899ce1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61899ce1",
  null
  
)

export default component.exports